package org.solyton.solawi.bid.module.i18n.`data`

import kotlin.String
import kotlin.collections.List
import kotlin.collections.Set
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.language.Lang
import org.evoleq.language.LangComponent
import org.evoleq.optics.lens.Lens

/**
 * Autogenerated Lens.
 * Read and manipulate [I18N.locale]
 */
@ReadWrite
public val locale: Lens<I18N, String> by lazy {
      Lens(
        get = { whole -> whole.locale },
        set = { part -> { whole -> whole.copy(locale = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [I18N.locale]
 */
@ReadWrite
public fun I18N.locale(`set`: String.() -> String): I18N = copy(locale = set(locale))

/**
 * Autogenerated Lens.
 * Read and manipulate [I18N.locales]
 */
@ReadWrite
public val locales: Lens<I18N, List<String>> by lazy {
      Lens(
        get = { whole -> whole.locales },
        set = { part -> { whole -> whole.copy(locales = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [I18N.locales]
 */
@ReadWrite
public fun I18N.locales(`set`: List<String>.() -> List<String>): I18N = copy(locales = set(locales))

/**
 * Autogenerated Lens.
 * Read and manipulate [I18N.language]
 */
@ReadWrite
public val language: Lens<I18N, Lang> by lazy {
      Lens(
        get = { whole -> whole.language },
        set = { part -> { whole -> whole.copy(language = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [I18N.language]
 */
@ReadWrite
public fun I18N.language(`set`: Lang.() -> Lang): I18N = copy(language = set(language))

/**
 * Autogenerated Lens.
 * Read and manipulate [I18N.loadedComponents]
 */
@ReadWrite
public val loadedComponents: Lens<I18N, Set<LangComponent>> by lazy {
      Lens(
        get = { whole -> whole.loadedComponents },
        set = { part -> { whole -> whole.copy(loadedComponents = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [I18N.loadedComponents]
 */
@ReadWrite
public fun I18N.loadedComponents(`set`: Set<LangComponent>.() -> Set<LangComponent>): I18N =
    copy(loadedComponents = set(loadedComponents))

/**
 * Autogenerated Lens.
 * Read and manipulate [I18N.loadingComponents]
 */
@ReadWrite
public val loadingComponents: Lens<I18N, Set<LangComponent>> by lazy {
      Lens(
        get = { whole -> whole.loadingComponents },
        set = { part -> { whole -> whole.copy(loadingComponents = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [I18N.loadingComponents]
 */
@ReadWrite
public fun I18N.loadingComponents(`set`: Set<LangComponent>.() -> Set<LangComponent>): I18N =
    copy(loadingComponents = set(loadingComponents))
